import React from 'react'
import PropTypes from 'prop-types'
import DataSource from '../DataSource'
import Addressify from '../elements/Addressify'
import ModuleWithLoader from '../components/ModuleWithLoader'
import TermsOfUseCheckbox from '../components/TermsOfUseCheckbox'
import TermsAndConditionsCheckbox from '../components/TermsAndConditionsCheckbox'
import FormHOC from './FormHOC'
import FancySelectRow from '../elements/FancySelectRow'
import InputRow from '../elements/InputRow'
import Button from '../elements/Button'
import FancySelectAdvancedRow from '../elements/FancySelectAdvancedRow'
import { SERVICE_NBN } from '../constants'
import store from '../store'
import ComparePlans from '../components/ComparePlans/ComparePlans'

const options = {
    postUrl: '/api/postUpgradeNbn',
    success: 'Your nbn&trade; order has been completed successfully.'
}
const state = {
    planId: null,
    usageId: 'unlimited',
    speed: '', // For GA event
    termsOfUse: false,
    termsAndConditions: false,
    referrerCode: '',
    existingPhone: 'No',
    transferPhone: 'No',
    modem: true
}

class UpgradeToNbnForm extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoadingPlans: false,
            plans: [],
            currentPlan: {}
        }
    }

    componentDidMount () {
        this.props.setDynamicValues({
            customerId: store.getState().auth.id
        })

        this.selectAddressIfSingle()
    }

    selectAddressIfSingle () {
        if (this.props.addresses.length === 1) {
            const onlyAddress = this.props.addresses[0].value
            this.props.setDynamicValues({
                addressData: onlyAddress
            }, () => {
                this.handleChangeAddress({ addressData: onlyAddress })
            })
        }
    }

    handleChangeAddress (data) {
        this.props.setDynamicValues({
            serviceId: data.addressData.id,
            address: data.addressData.address,
            serviceClass: data.addressData.service_class
        })
        this.setState({
            isLoadingPlans: true,
            plans: []
        }, () => this.getPlans(data.addressData.service_class))
    }

    getPlans (serviceClass) {
        DataSource.getData(`/api/getUpgradeNbnPlans/${serviceClass}`, result => {
            this.setState({
                plans: result.plans
            })
        })
    }

    handleChangePlan (id) {
        this.props.setDynamicValues({
            planId: id
        }, this.setCurrentPlan.bind(this))
    }

    handleChange (value) {
        this.props.setDynamicValues(value)
    }

    setCurrentPlan () {
        this.state.plans.map(plan => {
            if (this.props.values.planId === plan.id) {
                this.setState({ currentPlan: plan })
                this.props.setDynamicValues({
                    speed: plan.planSpeed, // For GA event
                    allowance: plan.allowance // For GA event
                })
            }
        })
    }

    mapExistingPlanFields () {
        return {
            title: 'N/A',
            data: '',
            speed: '',
            eveningSpeed: '',
            price: '',
            features: []
        }
    }

    mapApiPlanFields () {
        const plans = []

        this.state.plans.forEach(plan => {
            let totalMinCost = (plan.price * 12) - plan.price
            if (plan.special) {
                const duration = parseInt(plan.special.duration.replace(' months', ''))
                totalMinCost = (plan.special.planPrice * duration) + (plan.price * (12 - duration))
            }

            plans.push({
                id: plan.id,
                title: plan.planTitle.replace(plan.planSpeed, 'speed'),
                data: plan.allowance,
                speed: `${plan.planSpeed} speed tier`,
                special: plan.special ? plan.special : null,
                eveningSpeed: plan.eveningSpeed,
                price: plan.price,
                totalMinCost: totalMinCost,
                features: [
                    '12-month contract',
                    'FREE modem and shipping'
                ]
            })
        })

        return plans
    }

    render () {
        return (
            <div>
                <div className='row'>
                    <div className='col-12 col-md-8 offset-md-2'>
                        {this.props.addresses.length > 0
                            ? <React.Fragment>
                                <h1 className='m-0 mb-4 text-center'>1. Select your address</h1>
                                <FancySelectAdvancedRow
                                    label='Select your address'
                                    name='addressData'
                                    options={this.props.addresses}
                                    value={this.props.values.addressData}
                                    handleChange={this.handleChangeAddress.bind(this)}
                                />
                              </React.Fragment>
                            : <p className='text-center'>Your account has no active Exetel ADSL broadband services which are currently nbn&trade; ready.</p>}
                    </div>
                </div>

                {this.state.isLoadingPlans
                    ? <ModuleWithLoader isLoaded={this.state.plans.length > 0}>
                        <div className='row'>
                            <div className='col-12 col-lg-12 px-2 px-lg-4 pt-4'>
                                <h2 className='text-center'>2. Choose your nbn&trade; plan below</h2>
                                <ComparePlans
                                    type={SERVICE_NBN}
                                    plans={this.mapApiPlanFields()}
                                    existingPlan={this.mapExistingPlanFields()}
                                    handleSelect={this.handleChangePlan.bind(this)}
                                    selectedPlanId={this.state.currentPlan.id}
                                />
                            </div>
                        </div>

                        {this.props.values.planId
                            ? <React.Fragment>
                                <div className='row mt-5'>
                                    <div className='col-12 col-md-8 offset-md-2'>
                                        <h1 className='m-0 mb-4 text-center'>3. Order your nbn&trade; upgrade</h1>
                                        <FancySelectAdvancedRow
                                            name='modem'
                                            label='<small>Do you need us to send you a FREE nbn&trade; ready WiFi modem? Choose no if you already have one.</small>'
                                            options={[
                                                { value: true, label: 'Yes' },
                                                { value: false, label: 'No' }
                                            ]}
                                            value={this.props.values.modem}
                                            errors={this.props.errors}
                                            handleChange={this.handleChange.bind(this)}
                                        />
                                        {this.props.values.modem
                                            ? <React.Fragment>
                                                <Addressify
                                                    label='Delivery address'
                                                    name='deliveryAddress'
                                                    value={this.props.values.deliveryAddress}
                                                    errors={this.props.errors}
                                                    handleSetAddress={this.props.setDynamicValues}
                                                    placeholder='Start typing your delivery address'
                                                >
                                                    <small>(We can't deliver to PO Box)</small>
                                                </Addressify>
                                                <InputRow
                                                    name='deliveryRecipient'
                                                    label='Delivery Recipient'
                                                    placeholder='Name of person accepting delivery'
                                                    value={this.props.values.deliveryRecipient}
                                                    errors={this.props.errors}
                                                    handleChange={this.props.handleInputChange}
                                                />
                                              </React.Fragment>
                                            : ''}
                                        <FancySelectRow
                                            name='existingPhone'
                                            label='Does your premises have an existing phone line?'
                                            options={['Yes', 'No']}
                                            value={this.props.values.existingPhone}
                                            errors={this.props.errors}
                                            handleChange={this.handleChange.bind(this)}
                                        />
                                        {this.props.values.existingPhone === 'Yes'
                                            ? <InputRow
                                                    name='phone'
                                                    label='Your phone number'
                                                    placeholder="Leave blank if you don't have a number"
                                                    value={this.props.values.phone}
                                                    errors={this.props.errors}
                                                    handleChange={this.props.handleInputChange}
                                            >
                                                <small>(The fixed line at your address)</small>
                                              </InputRow>
                                            : ''}
                                        {this.props.values.phone && this.props.values.phone.length > 0
                                            ? <FancySelectRow
                                                    name='transferPhone'
                                                    label='Do you want to transfer this number as your Exetel Home Phone number?'
                                                    options={['Yes', 'No']}
                                                    value={this.props.values.transferPhone}
                                                    errors={this.props.errors}
                                                    handleChange={this.handleChange.bind(this)}
                                            />
                                            : ''}
                                        {this.props.values.transferPhone === 'Yes'
                                            ? <InputRow
                                                    name='accountNumber'
                                                    label='Account number'
                                                    placeholder='The account number of your current provider'
                                                    value={this.props.values.accountNumber}
                                                    errors={this.props.errors}
                                                    handleChange={this.props.handleInputChange}
                                            />
                                            : ''}
                                    </div>
                                </div>

                                <div className='row my-3'>
                                    <div className='col-12 col-md-8 offset-md-2'>
                                        <TermsOfUseCheckbox
                                            errors={this.props.errors}
                                            value={this.props.values.termsOfUse}
                                            handleClick={value => this.props.setDynamicValues({ termsOfUse: value })}
                                            cisUrl='https://files.exetel.com.au/cis/nbn/switch/CIS_nbn_FTTX_ADSL-NBN.pdf'
                                            termsUrl='https://www.exetel.com.au/broadband/nbn/terms'
                                        />
                                        <br />
                                        <TermsAndConditionsCheckbox
                                            errors={this.props.errors}
                                            value={this.props.values.termsAndConditions}
                                            handleClick={value => this.props.setDynamicValues({ termsAndConditions: value })}
                                            type={SERVICE_NBN}
                                        />
                                        <br />
                                        {this.props.children}
                                    </div>
                                </div>

                                <div className='row my-4'>
                                    <div className='col-12 col-md-4 offset-md-2 text-center text-md-left my-2'>
                                        <Button title='Place Order' action={this.props.handleSubmit} />
                                    </div>
                                    <div className='col-12 col-md-4 text-center text-md-right my-2'>
                                        <input placeholder='Referrer Code' name='referrerCode' value={this.props.values.referrerCode} onChange={this.props.handleInputChange} />
                                    </div>
                                </div>
                              </React.Fragment>
                            : ''}
                      </ModuleWithLoader>
                    : ''}
            </div>
        )
    }
}

UpgradeToNbnForm.propTypes = {
    addresses: PropTypes.array.isRequired,
    speedId: PropTypes.string
}

export default FormHOC(UpgradeToNbnForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/UpgradeToNbnForm.js